<template>
   <v-container fluid > 

       <v-row style="width:100%">
        <iframe ref="iframe" width="100%" height="390" style="border: none; overflow:hidden;"></iframe>
     </v-row>

    </v-container>
</template>

<script> 
import BaseModule from '../../common/BaseModule.js'

export default {
  name: 'IframeWidget',
  mixins: [BaseModule],
  components: { 

  },
   props: ['config','context'],
  
  data() {
      return {
        isLoading: true,
        iframeSource: null
      }
  },mounted() {
        this.update();
    },
    watch: {
      context: function() { 
        this.update();
      }
    },
   methods: {
    update() {
       console.log(this.$refs);
       let iframeConfig = this.config.fields?JSON.parse(this.config.fields):{};
       this.$refs.iframe.src = iframeConfig.source?iframeConfig.source:'about:blank';

       let scrolling=iframeConfig.scrolling?iframeConfig.scrolling:"yes";
       this.$refs.iframe.scrolling=scrolling;
    },
   }
};
</script>
 